import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  AIONZ_DIALOG_DATA,
  AionzDialogModule,
  AionzDialogRef,
  HeaderBottomSheetComponent
} from '@aionzdev/design-system';
import { ApprovalReviewData, ApprovalReviewResult } from '../../../interfaces/approval-review';
import { ApprovalReviewComponent } from '../approval-review/approval-review.component';

/**
 * Quadro de revisão antes da aprovação, no mapa: o conteúdo é o `aionz-approval-review` (o
 * mesmo da tela de aprovação). Somente leitura; para corrigir, o usuário volta ao mapa.
 * "Continuar" leva ao dialog de justificativa.
 */
@Component({
  selector: 'aionz-approval-review-dialog',
  imports: [AionzDialogModule, ApprovalReviewComponent, HeaderBottomSheetComponent, MatButtonModule],
  templateUrl: './approval-review-dialog.component.html',
  styleUrl: './approval-review-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApprovalReviewDialogComponent {
  protected readonly data = inject<ApprovalReviewData>(AIONZ_DIALOG_DATA);
  private readonly dialogRef = inject<AionzDialogRef<ApprovalReviewDialogComponent, ApprovalReviewResult>>(AionzDialogRef);

  protected close(): void {
    this.dialogRef.close(undefined);
  }

  protected continue(): void {
    this.dialogRef.close('continue');
  }
}
